import {
    type AttachClientContactInput,
    type GetClientPersonOutput,
    toUsStateName,
} from '@/entities/client';
import { formatPhone } from '@/shared/lib/format-utils';

type PersonFields = Pick<AttachClientContactInput, 'emailPrimary' | 'phonePrimary' | 'address'>;

// FR-012: the saved details, empty where nothing is saved. The phone is masked and the state named
// here because the form's fields hold those, and a raw seed would dirty the form on mount.
export function buildExistingPersonFields(person: GetClientPersonOutput): PersonFields {
    return {
        emailPrimary: person.emailPrimary ?? '',
        phonePrimary: formatPhone(person.phonePrimary),
        address: {
            street1: person.address?.street1 ?? '',
            street2: person.address?.street2 ?? '',
            city: person.address?.city ?? '',
            state: toUsStateName(person.address?.state ?? ''),
            zip: person.address?.zip ?? '',
        },
    };
}
